import React from 'react';

import * as S from './styles';

const MONTH_NAMES = [
  'JANEIRO',
  'FEVEREIRO',
  'MARÇO',
  'ABRIL',
  'MAIO',
  'JUNHO',
  'JULHO',
  'AGOSTO',
  'SETEMBRO',
  'OUTUBRO',
  'NOVEMBRO',
  'DEZEMBRO'
];

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'R$ 0,00';
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return formatter.format(amount);
};

const getMonthYearLabel = (month, year) => {
  if (!month || !year) return '';
  const monthName = MONTH_NAMES[month - 1] || '';
  return `${monthName}/${year % 100}`;
};

const buildBalanceSheetRowsStandard = (balance) => {
  const rows = [];

  if (!balance) return rows;

  const {
    bankAccount,
    incomeBalanceAmount = 0,
    expenseBalanceAmount = 0,
    transferBalanceAmount = 0,
    monthBalanceAmount = 0,
    year,
    month
  } = balance;

  // Header row with bank account and month/year
  const bankAccountName = bankAccount?.name || 'Conta Corrente';
  const monthYearLabel = getMonthYearLabel(month, year);
  rows.push({
    label: bankAccountName,
    value: monthYearLabel,
    isHeader: false,
    indent: 0,
    isBoundary: true
  });

  // Calculate initial balance
  const initialBalance = monthBalanceAmount - (incomeBalanceAmount + expenseBalanceAmount + transferBalanceAmount);
  rows.push({
    label: 'Saldo Inicial',
    value: formatCurrency(initialBalance),
    isHeader: true,
    indent: 0,
    isBoundary: true
  });

  // Income row
  rows.push({
    label: 'Receitas',
    value: formatCurrency(incomeBalanceAmount),
    isHeader: true,
    indent: 0,
    isBoundary: true
  });

  // Expenses row
  rows.push({
    label: 'Despesas',
    value: formatCurrency(expenseBalanceAmount),
    isHeader: true,
    indent: 0,
    isBoundary: true
  });

  // Transfers row
  rows.push({
    label: 'Transferências',
    value: formatCurrency(transferBalanceAmount),
    isHeader: true,
    indent: 0,
    isBoundary: true
  });

  // Final balance row
  rows.push({
    label: 'Saldo Final',
    value: formatCurrency(monthBalanceAmount),
    isHeader: true,
    indent: 0,
    isBoundary: true
  });

  return rows;
};

export const BalanceSheetStandard = ({ dataBilling }) => {
  const balance = dataBilling?.balance;

  if (!balance) {
    return null;
  }

  const rows = buildBalanceSheetRowsStandard(balance);

  if (rows.length === 0) {
    return null;
  }

  return (
    <S.Section>
      <S.Container>
        <S.SubTitle>Balancete Sintético</S.SubTitle>

        <S.Table>
          <S.TableBody>
            {rows.map((row, idx) => {
              const paddingLeft = row.indent > 0 ? `${10 + row.indent * 20}px` : '10px';
              const borderStyle = row.isBoundary ? '1px solid #dfe1e6' : 'none';
              const borderBottom = borderStyle;
              const borderTop = row.isBoundary && idx > 0 ? borderStyle : 'none';

              const RowComponent = row.isHeader ? S.TableRow : S.TableRowBody;
              const CellComponent = row.isHeader ? S.TableHead : S.TableCell;

              return (
                <RowComponent key={idx}>
                  <CellComponent
                    style={{
                      borderBottom,
                      borderTop,
                      paddingLeft,
                      fontWeight: row.isHeader ? '600' : 'normal'
                    }}
                  >
                    {row.label}
                  </CellComponent>
                  <CellComponent
                    style={{
                      borderBottom,
                      borderTop,
                      textAlign: 'right',
                      fontWeight: row.isHeader ? '600' : 'normal'
                    }}
                  >
                    {row.value}
                  </CellComponent>
                </RowComponent>
              );
            })}
          </S.TableBody>
        </S.Table>
      </S.Container>
    </S.Section>
  );
};
